import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-non-paye-facture',
  templateUrl: './non-paye-facture.component.html',
  styleUrls: ['./non-paye-facture.component.scss']
})
export class NonPayeFactureComponent implements OnInit {

    currentUser: any = null;
    stationId: number | null = null;

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastrService
    ) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
        this.stationId = this.currentUser?.stations?.[0]?.id || null;
    }

    ngOnInit(): void {
        // ON VÉRIFIE QUE LA STATION EXISTE
        if (!this.stationId) {
            this.toastr.warning('Aucune station trouvée. Redirection...', 'Attention');
            setTimeout(() => this.router.navigate(['/create-station']), 2000);
            return;
        }

        // ON CHARGE LES FACTURES "Non payé" AVEC LA BONNE MÉTHODE
        this.dataService.loadByTypeAndStatus('facture', 'Non Payé');
    }
}
